import { patientAction } from 'src/redux/actions/constant';

const {
  GET_PATIENT_EXPORT_TEMPLATE_RESET,
  GET_PATIENT_EXPORT_TEMPLATE_SUCCESS,
  GET_PATIENT_EXPORT_TEMPLATE_FAILURE,
} = patientAction;

const intitialstate: object = {
  isExportSuccess: false,
  response: null,
};

export const getPatientExportCsvReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_EXPORT_TEMPLATE_SUCCESS: {
      return {
        ...state,
        isExportSuccess: true,
        response: action.payload,
      };
    }

    case GET_PATIENT_EXPORT_TEMPLATE_FAILURE:
      return {
        ...state,
        isExportSuccess: false,
        response: action.payload,
      };

    case GET_PATIENT_EXPORT_TEMPLATE_RESET:
      return intitialstate;

    default:
      return state;
  }
};
